import { ReactNode } from 'react';
import clsx from 'clsx';

interface BadgeProps {
  children: ReactNode;
  variant?: 'default' | 'new' | 'chinese' | 'japanese' | 'korean' | 'vietnamese' | 'thai' | 'asian' | 'status' | 'success' | 'info' | 'warning' | 'danger';
  statusType?: 'new' | 'contacted' | 'qualified' | 'closed';
  className?: string;
}

export function Badge({ children, variant = 'default', statusType, className }: BadgeProps) {
  const baseStyles = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';

  const variants = {
    default: 'bg-gray-100 text-gray-800',
    new: 'bg-brand-secondary text-brand-primary',
    chinese: 'bg-red-100 text-red-800',
    japanese: 'bg-pink-100 text-pink-800',
    korean: 'bg-blue-100 text-blue-800',
    vietnamese: 'bg-yellow-100 text-yellow-800',
    thai: 'bg-orange-100 text-orange-800',
    asian: 'bg-purple-100 text-purple-800',
    status: '',
    success: 'bg-green-100 text-green-800',
    info: 'bg-blue-100 text-blue-800',
    warning: 'bg-yellow-100 text-yellow-800',
    danger: 'bg-red-100 text-red-800',
  };

  const statusVariants = {
    new: 'bg-green-100 text-green-800',
    contacted: 'bg-blue-100 text-blue-800',
    qualified: 'bg-yellow-100 text-yellow-800',
    closed: 'bg-gray-100 text-gray-500',
  };

  const variantStyles = variant === 'status' && statusType
    ? statusVariants[statusType]
    : variants[variant];

  return (
    <span className={clsx(baseStyles, variantStyles, className)}>
      {children}
    </span>
  );
}

export function getCuisineBadgeVariant(cuisine: string | null): BadgeProps['variant'] {
  if (!cuisine) return 'default';

  const lower = cuisine.toLowerCase();
  if (lower.includes('chinese')) return 'chinese';
  if (lower.includes('japanese')) return 'japanese';
  if (lower.includes('korean')) return 'korean';
  if (lower.includes('vietnamese')) return 'vietnamese';
  if (lower.includes('thai')) return 'thai';
  if (lower.includes('asian')) return 'asian';
  return 'default';
}
